
import { ImportQuotesTab } from "@/components/admin/quotes/ImportQuotesTab";

const ImportQuotes = () => {
  return <ImportQuotesTab />;
};

export default ImportQuotes;
